import TicketCategoryList from './TicketCategoryList';

export default TicketCategoryList;
